export class MatchTime {
    displayTime: string;
    regularTime: string;
    remainingTime: string;
    remainingTimeInPeriod: string;
    stoppageTime: string;
}